<template>
  <transition name="fade">
    <div>
      <div class="container" style="text-align: center">
        <img
          src="https://media.privateupgrades.com/layout/images/logo-color.png"
          class="img-responsive container__img-logo"
          alt="PrivateUpgrades"
          width="379px"
          height="65px"
        />
        <br>
        <span class="h1_format container__text container__text_desktop">
          Checking availability for <strong>{{ title }}</strong> from
          <strong>{{ check_in_date }}</strong> to <strong>{{ check_out_date }}</strong>
        </span>

        <span class="h1_format container__text container__text_mobile">
          Checking availability <br>
          for <strong>{{ title }}</strong> from <strong>{{ check_in_date }}</strong> to <strong>{{ check_out_date }}</strong>
        </span>

  <br><br>
        <lottie-player src="/assets/json/search_lottie.json"  
            background="transparent"  speed="1"  style="margin-left:auto; margin-right:auto; display:block; width:100%; height:auto;"  loop  autoplay></lottie-player> 
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LoadingComponent",
  props: ["requestData", "title", "check_out_date", "check_in_date"],
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.container {
  display: block;
  width: 60%;
  border: 3px solid #f0be35;
  background-color: white;
  border-radius: 5px;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  min-height: 370px ;
  font-size: 1.5em;
}
.container__text_desktop{
  display:inline;
}
.container__text_mobile{
  display:none;
}

@media (min-width: 1200px) {
  .container {
    width: 650px;
    height: auto ;
  }
}
@media (max-width: 768px) {
  .container {
    width: 95%;
    min-height: 300px ;
  }
  .container__text {
     font-size: 16px;
  }
  .container__text_desktop{
  display:none;
}
.container__text_mobile{
 display:inline;
}
}

.container__text {
  padding-top: 1em;

}
.container__img-logo {
  padding-top: 2em;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

</style>